import { receiveData, receiveError } from '../api/http'
import CloudFlyerAPI from '../api/CloudFlyerAPI'

export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS'
export const FETCH_ROLES_ERROR   = 'FETCH_ROLES_ERROR'

export function fetchRoles() {
  return (dispatch, getState) => {
    CloudFlyerAPI
      .user_account
      .roles
      .fetchAll()
      .then(({ data }) => {
        dispatch(receiveData(FETCH_ROLES_SUCCESS, data))
      })
      .catch(err => {
        dispatch(receiveError(FETCH_ROLES_ERROR, err))
      })
  }
}
